/* eslint-disable jsx-a11y/no-distracting-elements */
import React from "react";
import style from "./emergencyContact.module.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import {
  API_AUTH_PASSWORD,
  API_AUTH_USERNAME,
  API_BASE_URL,
  ADMIN_ID,
} from "../../Constant/Global";
import Loader from "../../components/loader/Loader";
import { MdWifiCalling3 } from "react-icons/md";

const EmergencyContact = () => {
  const [contactData, setContactData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // contact api

  const handleContactData = async () => {
    try {
      const finalData = { admin_id: ADMIN_ID };
      // console.log("finalData", finalData);
      const response = await axios.post(
        API_BASE_URL + "web/emergency_contact",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      // console.log("contact response", response.data.data);
      setIsLoading(false);
      setContactData(response.data.data);
    } catch (error) {
      console.log(error.response);
    }
  };

  useEffect(() => {
    handleContactData();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div
          className={`container-fluid ps-0 pe-0 ${style.scheme_container_fluid}`}
        >
          {/* Schemes row */}
          <div className={`row ${style.emergency_row}`}>
            <header className={`${style.schemes_top_common_title_sec}`}>
              <span className={`${style.emergency_c_span_title}`}>
                emergency numbers
              </span>
              <h5 className={`${style.emergency_bottom_title}`}>
                Your Emergency Contact – Quick Access in Critical Moments
              </h5>
            </header>
            <div className={`col-lg-5 ${style.emergency_col_center}`}>
              <div className={`${style.emergency_contact_main_sec}`}>
                {contactData?.emergency_contact?.map((ele) => {
                  return (
                    <div key={ele.id} className={`${style.sub_sec_em_contact}`}>
                      <div className={`${style.profile_summary_sec}`}>
                        <img
                          src={ele.image}
                          alt="contact"
                          className="img-fluid"
                          loading="lazy"
                        />
                        <div className={`${style.name_number_info_sec}`}>
                          <p className={`${style.person_to_enq_name}`}>
                            {ele.name} <span> {ele.role}</span>
                          </p>
                          <h5 className={`${style.person_to_enq_number}`}>
                            {ele.mobile}
                          </h5>
                        </div>
                      </div>
                      <Link
                        to={`tel:${ele.mobile}`}
                        className={`${style.emergency_contact_btn}`}
                      >
                        {" "}
                        <img
                          src={require("../../assets/images/emergenchy-contact/call-now.png")}
                          alt="call now"
                          className="img-fluid"
                          loading="lazy"
                        />{" "}
                        call now
                      </Link>
                      <Link
                        to={`tel:${ele.mobile}`}
                        className={`${style.emergency_contact_btn_mobile}`}
                      >
                        <MdWifiCalling3 />
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {/* client logos */}
          <div className={`row ${style.client_logo_row}`}>
            <div className="col-lg-12 ps-0 pe-0">
              <ul className={`${style.client_logo_ul_list}`}>
                {contactData?.co_partner?.map((ele) => {
                  return (
                    <li key={ele.id} className={`${style.client_logo_list}`}>
                      <img
                        src={ele.image}
                        alt="client"
                        loading="lazy"
                        className="img-fluid"
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EmergencyContact;
